module.exports = __webpack_public_path__ + "static/media/ios-arrow-round-back.c3a732cd.svg";